import React from 'react';
import logoMyTest from '../../assets/logo.png';
import nswHealthLogo from '../../img/logo-footer.png';
import machineImage from '../../assets/machine.png';
import '../../scss/_thank-you-page.scss';

export default function ThankYouPage() {

  return (
    <div className="thank-you-page">
      <div className="thank-you-container">
        {/* Logo */}
        <div className="thank-you-logo">
          <img src={logoMyTest} alt="MyTest logo" />
        </div>

        {/* Purple card with thank you message */}
        <div className="thank-you-card">
          <h1 className="thank-you-title">Thank you</h1>
          <p className="thank-you-message">
            You have successfully dispensed your self-test kit.
          </p>

          {/* Machine illustration */}
          <div className="machine-illustration">
            <img src={machineImage} alt="MyTest vending machine" />
          </div>
        </div>

        {/* Footer */}
        <div className="thank-you-footer">
          <div className="footer-divider"></div>
          <div className="footer-logo">
            <img src={nswHealthLogo} alt="NSW Health logo" />
          </div>
          <div className="footer-copyright">© 2025 All Rights Reserved.</div>
          <div className="footer-links">
            <a
              href="https://www.health.nsw.gov.au/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              NSW Health
            </a>
            <a
              href="https://mytest.health.nsw.gov.au/en-US/Term/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Terms
            </a>
            <a
              href="https://mytest.health.nsw.gov.au/en-US/Privacy/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Privacy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}